import { ApiError, getErrorMessage } from '@pro4-erp/core-web';

export const getMessageFromError = (error: Error): string => {
  if (error instanceof ApiError) {
    return getErrorMessage(error.errorResponseDto.message);
  }

  return 'An unknown error occurred.';
};

export const checkIfErrorIsAccessAuthorizationError = (error: Error): boolean => {
  if (error instanceof ApiError) {
    return error.errorResponseDto.message === 'No access authorisation!';
  }

  return false;
};
